export const changeSymbol = (str: string) => {
	const copyright = str.replaceAll(/\(C\)*/gi, '©');
	const tm = copyright.replaceAll(/\(TM\)*/gi, '™');
	const registered = tm.replaceAll(/\(R\)*/gi, '®');

	return registered;
};

export const iconSizeNumber = (size?: string | null): number => {
	const sizes = {
		Small: 32,
		Medium: 48,
		Large: 64,
		XLarge: 68,
	} as { [key: string]: number };
	return sizes[size ?? 'Large'] ?? sizes.Large;
};
